import React from 'react';
import Header from './header';
import Content from './content';
import Footer from './footer';
import Paper from 'material-ui/Paper';

export default () => {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    height: '100vh'
  }
  return (
    <div className='layout' style={style}>
      <Paper
        zDepth={1}
        rounded={false}
        style={{display: 'flex', flex: '0 0 60px', background: '#eee', zIndex: '100'}}
      >
        <Header />
      </Paper>
      <Paper
        zDepth={0}
        rounded={false}
        style={{display: 'flex', flex: '1 0 auto', paddingTop: '20px', paddingBottom: '20px'}}
      >
        <Content />
      </Paper>
      <Paper
        zDepth={2}
        rounded={false}
        style={{display: 'flex', flex: '0 0 80px', padding: '10px', zIndex: '100', background: '#ddd'}}
      >
        <Footer />
      </Paper>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/layout/index.js